import React from 'react';
import * as colors from 'style/color';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCheck, faStar} from '@fortawesome/free-solid-svg-icons';

type StepProps = {
  name: string;
  status: 'checked' | 'active' | 'disable';
};

function Step(props: StepProps) {
  const {status, name} = props;

  let stepColor: string;
  switch (status) {
    case 'active':
      stepColor = colors.primary;
      break;
    case 'disable':
      stepColor = '#D2D2D2';
      break;
    default:
      stepColor = colors.dark;
  }

  return (
    <div
      className={'flex items-center'}
      style={{
        color: stepColor,
      }}
    >
      <FontAwesomeIcon
        icon={status === 'checked' ? faCheck : faStar}
        className={'mr-1 !w-4'}
      />
      <span>{name}</span>
    </div>
  );
}

export default Step;
